import {
  combineReducers,
  configureStore,
  getDefaultMiddleware
} from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import addPersonalReducer from "redux/modules/addPersonalSlice";
import addressReducer from "redux/modules/addressSlice";
import adminNotificationSlice from "redux/modules/adminNotificationSlice";
import allDocumentsSearchSlice from "redux/modules/allDocumentsSearchSlice";
import allDocumentsReducer from "redux/modules/allDocumentsSlice";
import authReducer from "redux/modules/authSlice";
import cancelVisaSlice from "redux/modules/cancelVisaSlice";
import companySlice from "redux/modules/companySlice";
import configActionSlice from "redux/modules/configActionSlice";
import configTimeSlice from "redux/modules/configTimeSlice";
import counterReducer from "redux/modules/counterSlice";
import dashboardReducer from "redux/modules/dashboardSlice";
import digitalWorkpermitListReducer from "redux/modules/digitalWorkpermitListSlice";
import employeeSlice from "redux/modules/employeeSlice";
import healthInsuranceReducer from "redux/modules/healthInsuranceSlice";
import holidaySlice from "redux/modules/holidaySlice";
import masterReducer from "redux/modules/masterSlice";
import ocrReducer from "redux/modules/ocrSlice";
import ownVisaSlice from "redux/modules/ownVisaSlice";
import passportReducer from "redux/modules/passportSlice";
import personalReducer from "redux/modules/personalSlice";
import pinSlice from "redux/modules/pinSlice";
import roleSliceReducer from "redux/modules/roleSlice";
import searchLocationSlice from "redux/modules/searchLocationSlice";
import statusReportSlice from "redux/modules/statusReportSlice";
import surrogateSlice from "redux/modules/surrogateSlice";
import transferJobSlice from "redux/modules/transferJobSlice";
import uiReducer from "redux/modules/uiSlice";
import userNotificationSlice from "redux/modules/userNotificationSlice";
import userReducer from "redux/modules/userSlice";
import visaFormReducer from "redux/modules/visaForm/slices";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: [],
};

const authConfig = {
  key: "auth",
  storage,
  blacklist: ["currentRole"],
};

const combinedReducer = combineReducers({
  master: masterReducer,
  auth: persistReducer(authConfig, authReducer),
  user: userReducer,
  personal: personalReducer,
  addPersonal: addPersonalReducer,
  counter: counterReducer,
  passport: passportReducer,
  visaForm: visaFormReducer,
  ocr: ocrReducer,
  role: roleSliceReducer,
  configAction: configActionSlice,
  allDocuments: allDocumentsReducer,
  ui: uiReducer,
  adminNotification: adminNotificationSlice,
  userNotification: userNotificationSlice,
  pin: pinSlice,
  cancelVisa: cancelVisaSlice,
  statusReport: statusReportSlice,
  allDocumentsSearch: allDocumentsSearchSlice,
  ownVisa: ownVisaSlice,
  searchLocation: searchLocationSlice,
  employee: employeeSlice,
  company: companySlice,
  holiday: holidaySlice,
  surrogate: surrogateSlice,
  configTime: configTimeSlice,
  transferJob: transferJobSlice,
  healthInsurance: healthInsuranceReducer,
  address: addressReducer,
  dashboard: dashboardReducer,
  digitalWorkpermitList: digitalWorkpermitListReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = { auth: state?.auth };
  }
  return combinedReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);

export default store;
